<template>
  <div
    class="c-tab c-tab--analysis"
    :class="[classes ? classes : '']"
  >
    <div class="c-tab__title">指標</div>
    <ul class="c-tab-list">
      <li
        class="c-tab-list__item"
        :class="[{'is-active': current == 'delivery'}]"
        data-type="delivery"
        @click="onSelect('delivery')"
      >
        配信対象
      </li>
      <li
        class="c-tab-list__item"
        :class="[{'is-active': current == 'impression'}]"
        data-type="impression"
        @click="onSelect('impression')"
      >
        インプレッション
      </li>
      <li
        class="c-tab-list__item"
        :class="[{'is-active': current == 'click'}]"
        data-type="click"
        @click="onSelect('click')"
      >
        クリック数
      </li>
      <li
        class="c-tab-list__item"
        :class="[{'is-active': current == 'ctr'}]"
        data-type="ctr"
        @click="onSelect('ctr')"
      >
        クリック率
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    classes: { type: String, required: false },
    current: { type: String, required: true },
    onSelect: { type: Function, required: true },
  },
  data() {
    return {}
  },
  methods: {},
}
</script>
